// modules
import { combineReducers } from 'redux'
// reducers
import chatBodyReducer from '../components/chat/components/body/main/chatBody.reducer'

export default combineReducers({
  chat: combineReducers({
    body: chatBodyReducer,
  }),
})
